import { render, staticRenderFns } from "./waitinglist.vue?vue&type=template&id=a3a132dc&scoped=true&"
import script from "./waitinglist.vue?vue&type=script&lang=js&"
export * from "./waitinglist.vue?vue&type=script&lang=js&"
import style0 from "./waitinglist.vue?vue&type=style&index=0&id=a3a132dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a132dc",
  null
  
)

export default component.exports